import { Box } from "@mui/material"
import { AddOutlined } from "@mui-symbols-material/w300"
import type { ReactElement } from "react"

import { Button } from "@/components/common/Button"
import type { Category } from "@/graphql/codegen/graphql"
import CategoryFormDialog from "@/screens/ManageProducts/components/ProductCategories/dialogs/CategoryFormDialog"

interface CategoryActionsProps {
  openedDialog: boolean
  setOpenedDialog: (isOpened: boolean) => void
  refreshData: () => void
  existingCategory?: Category
  setExistingCategory: (category?: Category) => void
}

const CategoryActions = ({
  refreshData,
  openedDialog,
  setOpenedDialog,
  existingCategory,
  setExistingCategory,
}: CategoryActionsProps): ReactElement => {
  return (
    <Box className='mb-4 flex items-center justify-end gap-2'>
      <Button color='primary' appearance='outlined' startIcon={<AddOutlined />} onClick={() => setOpenedDialog(true)}>
        New Product Category
      </Button>
      {openedDialog && (
        <CategoryFormDialog
          onSuccess={refreshData}
          onClose={() => {
            setOpenedDialog(false)
            setExistingCategory(undefined)
          }}
          existingCategory={existingCategory}
        />
      )}
    </Box>
  )
}

export default CategoryActions
